<template>
  <div>
    <data-table :service="service"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                :disable-permission-checks="true"
                operations="add,edit,delete"
                ref="table">
      <template v-slot:job_board_id="{row}">
        <router-link v-if="row.job_board_id" :to="`/content/job-board/${row.job_board_id}`" @click.native.stop="">
          {{getJobBoardName(row.job_board_id) || $t('generic.na')}}
        </router-link>
        <span v-else>
          {{getJobBoardName(row.job_board_id) || $t('generic.na')}}
        </span>
      </template>
      <template v-slot:title="{row}">
        <div class="flex items-center">
          <base-avatar :name="row.title"
                       :circle="false"
                       size="lg"
                       class="post-image"
                       :src="row.image">
          </base-avatar>
          <div class="ml-3">
            <div class="font-weight-bold">
              {{row.title}}
            </div>
            <p>{{row.description}}</p>
          </div>
        </div>
      </template>
      <template v-slot:query="{row}">
        <div v-if="row.query">
          <div v-if="row.query.search" class="flex items-center mb-1">
            <span class="mr-1 mb-1">{{$t('generic.keywords')}}:</span>
            <div>
              <badge v-for="keyword in row.query.search"
                     :key="keyword"
                     type="info"
                     class="mr-1 mb-1 d-inline-flex">
                {{keyword}}
              </badge>
            </div>
          </div>
          <div v-if="row.query.segments" class="flex items-center mb-1">
            <span class="mr-1 mb-1">{{$t('generic.segments')}}:</span>
            <div>
              <badge v-for="segmentId in row.query.segments"
                     :key="segmentId"
                     class="mr-1 mb-1 d-inline-flex">
                <span class="text-white">{{getSegmentById(segmentId).value}}</span>
              </badge>
            </div>
          </div>
          <div v-if="row.query.location" class="flex items-center mb-1">
            <span class="mr-1 mb-1">{{$t('generic.location')}}:</span>
            <div>
              <badge :key="row.query.location"
                     type="success"
                     class="mr-1 mb-1 d-inline-flex">
                {{row.query.location}}
              </badge>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:created_by="{row}">
        <span>{{row.created_by || 'N/A'}}</span>
      </template>
      <template v-slot:created_at="{row}">
        <span>{{$formatDate(row.created_at, FRIENDLY_DATE_FORMAT)}}</span>
      </template>
    </data-table>
  </div>
</template>
<script>
  import { entities } from 'src/config/routeTypes'
  import LandingPageService from 'src/services/LandingPageService'
  import { FRIENDLY_DATE_FORMAT } from 'src/config/dateUtils'
  import Badge from 'src/components/Badge'

  export default {
    name: 'landing-pages-list',
    components: {
      Badge
    },
    props: {
      filters: {
        type: Array,
        default: () => []
      },
      hideJobBoard: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        service: LandingPageService,
        entity: entities.LANDING_PAGE,
        FRIENDLY_DATE_FORMAT
      }
    },
    computed: {
      columns () {
        const jobBoardColumn = {
          prop: 'job_board_id',
          label: this.$t('searchSuggestions.list.jobBoard'),
          minWidth: '140px',
          sortable: true
        }
        const columns = [
          {
            prop: 'title',
            label: this.$t('generic.title'),
            minWidth: '320px',
            sortable: true
          },
          {
            prop: 'query',
            label: this.$t('searchSuggestions.list.query'),
            minWidth: '350px',
            sortable: true
          },
          {
            prop: 'group',
            label: this.$t('generic.group'),
            minWidth: '170px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '170px',
            sortable: true
          }
        ]
        if (!this.hideJobBoard) {
          columns.splice(1, 1, jobBoardColumn)
        }
        return columns
      },
      getJobBoardById () {
        return this.$store.getters['config/getJobBoardById']
      },
      getSegmentById () {
        return this.$store.getters['config/getSegmentById']
      },
    },
    methods: {
      getJobBoardName (id) {
        let jobBoard = this.getJobBoardById(id) || {}
        return jobBoard.name
      },
    }
  }
</script>
<style>
</style>
